var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"video-avatar"}},[_c('div',{staticClass:"video-container"},[_c('span',{attrs:{"id":"status"}}),_c('span',{attrs:{"id":"counter"}}),_c('video',{attrs:{"id":"talk_video","x-webkit-airplay":"allow","preload":"yes","muted":"","autoplay":"","playsinline":"","loop":""},domProps:{"muted":true}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }